/**
 *
 *
 * @author fuyg
 * @date  2020-06-09
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from 'src/pages/home/store'
import {
  NewsDetailResponseData,
  NewsDetailRequestParams,
  getNewsDetail,
} from 'src/pages/home/apis/newsDetail'

interface NewsDetailState {
  loading: boolean
  error: string
  data: NewsDetailResponseData | null
}

const initialState: NewsDetailState = {
  loading: false,
  error: '',
  data: null,
}

const newsDetailSlice = createSlice({
  name: 'newsDetailSlice',
  initialState,
  reducers: {
    getDataStart(state): void {
      state.loading = true
    },
    getDataSuccess(state, action: PayloadAction<NewsDetailResponseData>): void {
      state.loading = false
      state.data = action.payload
    },
    getDataError(state, action: PayloadAction<string>): void {
      state.loading = false
      state.error = action.payload
    },
  },
})

export const {
  getDataStart,
  getDataSuccess,
  getDataError,
} = newsDetailSlice.actions

export default newsDetailSlice.reducer

export const fetchNewsDetail = (
  params: NewsDetailRequestParams,
): AppThunk => async (dispatch): Promise<void> => {
  try {
    dispatch(getDataStart())
    const data = await getNewsDetail(params)
    dispatch(getDataSuccess(data))
  } catch (err) {
    dispatch(getDataError(err as string))
  }
}
